import {Component, Input} from '@angular/core';

@Component({
  selector: 'storever-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss']
})
export class TabComponent {

  @Input() title: string;
  @Input() active = false;
  @Input() content: string;
  @Input() role: string;
}
